/* External dependencies */
import { gql } from '@apollo/client';

export const getWarehouseQuery = gql`
  query getWarehouse($input: GetWarehouseInput!) {
    getWarehouse(input: $input) {
      id
      city
      country
      createdDate
      address
      phone
      postcode
      region
      status
      updatedDate
    }
  }
`;
